// extracted by mini-css-extract-plugin
export default {"cont":"BeginButton_cont__9svIS","beginBtn":"BeginButton_beginBtn__etDah","vertilcalLine":"BeginButton_vertilcalLine__w41AO","lineGrowing":"BeginButton_lineGrowing__eSlGO"};